export function gtag(...args) {
  window.dataLayer?.push(arguments);
}
export function initGtag({ tags }) {
  window.dataLayer = window.dataLayer || [];
  for (const tag of tags) {
    for (const command of tag.initCommands ?? [])
      gtag(...command);
  }
  gtag("js", /* @__PURE__ */ new Date());
  for (const tag of tags) {
    gtag("config", tag.id, tag.config ?? {});
  }
}
